export default {
  imgPath: (state) => (imgFileName) => {
    return `${state.apiBaseUri}db/${imgFileName}`;
  },
  prevRoutePath: (state) => {
    const historyLen = state.routerHistory.length;
    if (historyLen == 0) return null;
    return state.routerHistory[historyLen - 1].path;
  },
  presentPersons: (state) => {
    return state.persons.filter((p) => p.present);
  },
  expectedPersons: (state) => {
    return state.persons.filter((p) => p.expected);
  },
};
